module.exports = __webpack_public_path__ + "assets/img/03-s.c47a54d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/03-s.jpg
// module id = /q6K
// module chunks = 0